// Copyright (c) 2025 Comsearch, Inc., All rights reserved

import { fetchWrapper } from "helpers/api";

export const fetchMailingListJobById = (id) =>
  fetchWrapper(`/mailing-list-exports/${id}`);
